const isArray = require('lodash/isArray')

module.exports = ['$q', '$utils', '$http', '$translate', 'User', 'Promise', 'globalMailService',
  function ($q, $utils, $http, $translate, User, Promise, globalMailService) {
    /*
         * function getAllFolder
         * @param fid 获取的folderId, 缺省获取根文件夹
         * @param flush 是否刷新folder结构, 缺省为true
         * @param stats 是否返回统计信息, 缺省为false
         * @param password 提供访问密码
         * Created by kpzeng
         */

    const getAllFolder = function (fid, options) {
      const deferred = $q.defer()
      const flush = options.flush || true
      const stats = options.stats || false
      const password = options.password || ''
      const isEntFolder = options.isEntFolder
      const query = {
        func: 'nf:getAllFolders',
        sid: User.getCurrentUser().sid
      }

      if (isEntFolder) {
        query.uid = getUid()
      }
      User.getCurrentUser().simpleCall({
        query: query,
        data: {
          fid: fid,
          flush: flush,
          stats: stats,
          password: password
        }
      }).then(function (data) {
        deferred.resolve(data)
      }, function (data) {
        deferred.reject(data)
      })

      return deferred.promise
    }

    /*
         * function: listFile
         * @param fid  文件夹ID
         * @param order   Optional,排序字段,(date: 按日期(上传日期)   size: 按大小  name: 按名称  suffix: 按文件名后缀排列)
         * @param desc    Optional,是否降序
         * @param start   Optional,缺省为0
         * @param limit   Optional,缺省不限制
         * @param generate   Optional,仅当值为 'auto' 时,自动生成图片 meta 信息
         * Created by kpzeng
         */
    const listFiles = function (fid, options) {
      const deferred = $q.defer()
      const order = options.order || 'date'
      const desc = options.desc || true
      const start = options.start || 0
      const limit = options.limit || 50
      const generate = options.generate
      /* 构造查询参数,由于query是处于地址栏的参数,所以不能像data里的为undefined时会被默认省略 */
      const query = {
        func: 'nf:listFiles',
        sid: User.getCurrentUser().sid
      }

      if (options.uid) {
        query.uid = options.uid
      }
      User.getCurrentUser().simpleCall({
        query: query,
        data: {
          fid: fid,
          order: order,
          desc: desc,
          start: start,
          limit: limit,
          generate: generate
        }
      }).then(function (data, status, headers, config) {
        deferred.resolve(data)
      }, function (data, status, headers, config) {
        deferred.reject(data)
      })

      return deferred.promise
    }
    /**
     * @description 列举来往附件
     * @param {Object} options 参数对象
     */
    function listAttachments(options) {
      const deferred = $q.defer()
      const params = {
        skipLockedFolders: true,
        desc: true,
        order: 'date',
        start: options.start || 0,
        limit: options.limit || 20,
        returnTotal: true,
        filter: {attn: options.attn || '', attType: ''}
      }
      Promise.wmCall('mbox:listAttachments', params).then(function(data) {
        deferred.resolve(data)
      }, function(error) {
        deferred.reject(error)
      })
      return deferred.promise
    }
    /**
     * @description 获取来往附件详情
     * @param {string} mid 附件所在邮件id
     * @param {string} partId 附件partId
     * @param {boolean} returnAttSize 是否返回精准大小
     */
    function readMessagePart(mid, partId, returnAttSize) {
      const deferred = $q.defer()
      const params = {
        id: mid,
        part: partId,
        autoName: true,
        returnTextContent: false,
        returnAttSize: returnAttSize,
        mboxa: ''
      }
      Promise.wmCall('mbox:readMessagePart', params).then(function(data) {
        deferred.resolve(data)
      }, function(error) {
        deferred.reject(error)
      })
      return deferred.promise
    }
    /*
         * function: createUserFolders
         * @param parentId Optional: 所在位置, 即父文件夹ID, 缺省创建到根
         * @param name 文件夹名称
         * @param memo 文件夹备注
         * Created by kpzeng
         */
    const createUserFolders = function (parentId, folderType, name, memo) {
      const deferred = $q.defer()
      const query = {
        func: 'nf:createUserFolders',
        sid: User.getCurrentUser().sid
      }
      if (folderType === 'ent') {
        query.uid = getUid()
      }
      User.getCurrentUser().simpleCall({
        query: query,
        data: {
          items: [{
            parent: parentId,
            name: name,
            memo: memo
          }]
        }
      }).then(function (data, status, headers, config) {
        if (data.code === 'S_OK') {
          deferred.resolve(data)
        } else {

        }
      }, function (data, status, headers, config) {
        let errorInfo
        switch (data.code) {
          case 'FA_OVERFLOW':
            errorInfo = $translate.instant('NETFOLDER.ERROR_MAX_FOLDER_STRICT')
            break
          case 'FA_NAME_EXISTS':
            errorInfo = $translate.instant('NETFOLDER.ERROR_DUBLICATE_FOLDER_NAME')
            break
          case 'FA_NAME_INVALID':
            errorInfo = $translate.instant('NETFOLDER.ERROR_INVALID_FOLDER_NAME')
            break
          default:
            errorInfo = $translate.instant('NETFOLDER.ERROR_UNKNOWN_ERROR')
        }
        $utils.$notify.set({message: errorInfo})

        deferred.reject(data)
      })
      return deferred.promise
    }

    /*
    * function: deleteFolder
    * @param folderId 文件夹ID
    * Created by kpzeng
    * 该函数用于删除文件夹所用，首先弹出确认窗让用户选择是否继续删除，如果文件夹为空且不为系统文件夹，则删除成功；
    * 否则若文件夹不为空，则再次提示用户是否删除该文件夹及其子内容，当不为系统文件夹时成功；
    */
    const deleteFolder = function (folderId) {
      const deferred = $q.defer()
      const confirm = $utils.$pop.confirmPopup('系统消息', '是否确认删除该文件夹')
      confirm.then(function (result) {
        if (result) {
          User.getCurrentUser().simpleCall({
            query: {
              func: 'nf:deleteFolders',
              sid: User.getCurrentUser().sid
            },
            data: {
              ids: [
                folderId
              ]
            }
          }).then(function (data, status, headers, config) {
            if (data.code === 'S_OK') {
              deferred.resolve(data)
            } else if (data.code === 'FA_FORBIDDEN') {
              $utils.$notify.set({message: $translate.instant('NETFOLDER.ERROR_CANT_DELETE_SYS_FOLDER')})

              // }else if (data.code === 'FA_HAS_CHILD' | data.code === 'FA_HAS_FILE') {
            } else {
              const confirm = $utils.$pop.confirmPopup('系统消息', '该文件夹不为空，是否删除该文件夹及其所有内容？')
              confirm.then(function (result) {
                if (result) {
                  deleteFolderR(folderId).then(function (data) {
                    deferred.resolve(data)
                  }).then(function (data) {
                    deferred.reject(data)
                  })
                } else {
                  deferred.reject(data)
                }
              })
            }
          }, function (data, status, headers, config) {
            deferred.reject(data)
          })
        } else {
          deferred.reject()
        }
      })
      return deferred.promise
    }

    /*
    * function: deleteFolder_R 删除文件夹及其所有内容
    * @param folderId 文件夹ID
    * Created by kpzeng
    */
    function deleteFolderR(folderIds, folderType) {
      folderIds = isArray(folderIds) ? folderIds : [folderIds]
      const deferred = $q.defer()
      const query = {
        func: 'nf:deleteFolders_R',
        sid: User.getCurrentUser().sid
      }
      if (folderType === 'ent') {
        query.uid = getUid()
      }
      User.getCurrentUser().simpleCall({
        query: query,
        data: {
          ids: folderIds
        }
      }).then(function (data, status, headers, config) {
        deferred.resolve(data)
      }, function (data, status, headers, config) {
        if (data.code === 'FA_FORBIDDEN') {
          $utils.$notify.set({message: $translate.instant('NETFOLDER.ERROR_CANT_DELETE_SYS_FOLDER')})
          deferred.reject(data)
        } else {
          $utils.$notify.set({message: $translate.instant('NETFOLDER.ERROR_UNKNOWN_ERROR')})
          deferred.reject(data)
        }
      })

      return deferred.promise
    }

    /*
         * function: reNameFolder
         * @param folderId 文件夹ID
         * @param name 新文件名
         * Created by kpzeng
         */
    const reNameFolder = function (folderId, name, folderType) {
      const deferred = $q.defer()
      const query = {
        func: 'nf:updateFolders',
        sid: User.getCurrentUser().sid
      }
      if (folderType === 'ent') {
        query.uid = getUid()
      }
      User.getCurrentUser().simpleCall({
        query: query,
        data: {
          items: [{
            id: folderId,
            name: name
          }]
        }
      }).then(function (data, status, headers, config) {
        deferred.resolve(data)
      }, function (data, status, headers, config) {
        let errorInfo
        switch (data.code) {
          case 'FA_FORBIDDEN':
            errorInfo = $translate.instant('NETFOLDER.ERROR_FORBIDDEN')
            break
          case 'FA_NAME_EXISTS':
            errorInfo = $translate.instant('NETFOLDER.ERROR_DUBLICATE_FOLDER_NAME')
            break
          case 'FA_NAME_INVALID':
            errorInfo = $translate.instant('NETFOLDER.ERROR_INVALID_FOLDER_NAME')
            break
          default:
            errorInfo = $translate.instant('NETFOLDER.ERROR_UNKNOWN_ERROR')
        }
        $utils.$notify.set({message: errorInfo})
        deferred.reject(data)
      })

      return deferred.promise
    }
    /*
         * function:
         * @param
         * Created by kpzeng
         */
    function searchFolders(fid, searchString, folderType) {
      const deferred = $q.defer()
      const query = {
        func: 'nf:searchFolders',
        sid: User.getCurrentUser().sid
      }
      if (folderType === 'ent') {
        query.uid = getUid()
      }
      User.getCurrentUser().simpleCall({
        query: query,
        data: {
          fid: [fid],
          operator: 'or',
          recursive: true,
          condictions: [
            {
              field: 'name',
              operator: 'contains',
              operand: searchString,
              ignoreCase: true
            },
            {
              field: 'memo',
              operator: 'contains',
              operand: searchString,
              ignoreCase: true
            }
          ],
          limit: 20,
          windowSize: 500
        }
      }).then(function (data, status, headers, config) {
        if (data.code === 'S_OK') {
          deferred.resolve(data)
        } else {
          deferred.reject()
        }
      }, function (data, status, headers, config) {
        deferred.reject(data)
      })

      return deferred.promise
    }

    /*
         * function:
         * @param
         * Created by kpzeng
         */
    function getFileInfos(mid, folderType) {
      const deferred = $q.defer()
      const query = {
        func: 'nf:getFileInfos',
        sid: User.getCurrentUser().sid
      }
      if (folderType === 'ent') {
        query.uid = getUid()
      }
      User.getCurrentUser().simpleCall({
        query: query,
        data: {
          ids: [mid]
        }
      }).then(function (data, status, headers, config) {
        if (data.code === 'S_OK') {
          deferred.resolve(data)
        } else if (data.code == 'S_PARTIAL_OK') {
          $utils.$notify.set({message: $translate.instant('TIPS.NOT_EXIT')})
          deferred.reject(data)
        }
      }, function (data, status, headers, config) {
        deferred.reject(data)
      })

      return deferred.promise
    }

    /*
         * function:
         * @param
         * Created by kpzeng
         * ps: 对于这种层级较深的回调实属无奈, 由于接口一定要得到uid才能请求,所以对于这种可能第一次访问的页面,
         * 只能使用这种两层回调的方法;
         */
    // function getEntFileInfos(mid, folderType) {
    //   const deferred = $q.defer()
    //   const self = this
    //   getEntUid().then(function () {
    //     self.getFileInfos(mid, folderType).then(function (data) {
    //       console.log(data)
    //       if (data.code === 'S_OK') {
    //         deferred.resolve(data)
    //       } else {
    //         deferred.reject(data)
    //       }
    //     })
    //   })
    //   return deferred.promise
    // }

    /*
         * function:
         * @param
         * Created by kpzeng
         */
    function searchFiles(fid, searchString, folderType, loadOptions) {
      const deferred = $q.defer()
      const start = loadOptions.start || 0
      const limit = loadOptions.limit || 50
      const query = {
        func: 'nf:searchFiles',
        sid: User.getCurrentUser().sid
      }
      if (folderType === 'ent') {
        query.uid = getUid()
      }
      User.getCurrentUser().simpleCall({
        query: query,
        data: {
          fid: [fid],
          operator: 'or',
          recursive: true,
          condictions: [
            {
              field: 'name',
              operator: 'contains',
              operand: searchString,
              ignoreCase: true
            },
            {
              field: 'memo',
              operator: 'contains',
              operand: searchString,
              ignoreCase: true
            }
          ],
          start: start,
          limit: limit,
          windowSize: 500
        }
      }).then(function (data, status, headers, config) {
        if (data.code === 'S_OK') {
          deferred.resolve(data)
        } else {
          deferred.reject()
        }
      }, function (data, status, headers, config) {
        deferred.reject(data)
      })

      return deferred.promise
    }

    /*
         * function:
         * @param
         * Created by kpzeng
         */
    /* webbview */
    function downloadFile(mid, isEnt) {
      isEnt = typeof isEnt === 'boolean' ? isEnt : false
      const queryData = {
        func: 'nf:getFileData',
        sid: User.getCurrentUser().sid,
        mode: 'download',
        mid: mid,
        uid: isEnt ? getUid() : null
      }
      const downloadUrl = User.getCurrentUser().wmsvrClient.getRequestURL({
        query: queryData
      })
      return downloadUrl
    }

    /* 浏览器 */
    function getDownloadUrl(mid) {
      const downloadUrl = '/downloadFile.jsp?mid=' + mid + '&sid=' + User.getCurrentUser().sid + '&mode=download'
      return downloadUrl
    }
    // 获取来往附件下载
    function getAttachmentDownloadUrl(mid, part) {
      const downloadUrl = '/readdata.jsp?mid=' + mid + '&part=' + part + '&sid=' + User.getCurrentUser().sid + '&mode=download'
      return downloadUrl
    }

    /*
         * function:
         * @param
         * Created by kpzeng
         */
    function updateFileInfo(mid, name, folderType) {
      const deferred = $q.defer()
      const query = {
        func: 'nf:updateFileInfos',
        sid: User.getCurrentUser().sid
      }
      if (folderType === 'ent') {
        query.uid = getUid()
      }
      User.getCurrentUser().simpleCall({
        query: query,
        data: {
          item: [{
            id: mid,
            name: name
          }]
        }
      }).then(function (data, status, headers, config) {
        if (data.code === 'S_OK') {
          deferred.resolve(data)
        }
      }, function (data, status, headers, config) {
        let errorInfo
        if (data) {
          switch (data.code) {
            case 'FA_NAME_EXISTS':
              errorInfo = $translate.instant('NETFOLDER.ERROR_FILE_HAS_EXSIT')
              break
            default:
              errorInfo = $translate.instant('NETFOLDER.ERROR_UNKNOWN_ERROR')
          }
          $utils.$notify.set({message: $translate.instant(errorInfo)})
        }
        deferred.reject(data)
      })
      return deferred.promise
    }

    /*
         * function:
         * @param
         * Created by kpzeng
         */
    function deleteFiles(fidList, folderType) {
      const deferred = $q.defer()
      const query = {
        func: 'nf:deleteFiles',
        sid: User.getCurrentUser().sid
      }
      if (folderType === 'ent') {
        query.uid = getUid()
      }
      User.getCurrentUser().simpleCall({
        query: query,
        data: {
          ids: fidList
        }
      }).then(function (data, status, headers, config) {
        if (data.code === 'S_OK') {
          deferred.resolve(data)
        }
      }, function (data, status, headers, config) {
        if (data) {
          $utils.$notify.set({message: $translate.instant('NETFOLDER.ERROR_UNKNOWN_ERROR')})
          deferred.reject(data)
        }
      })

      return deferred.promise
    }

    /*
         * 用于获取用户所在组织的网盘用户的共享文件夹列表
         * function: getEntFolderList
         * @param null
         * Created by kpzeng
         */
    function getEntFolderList(fid, options) {
      const deferred = $q.defer()
      const self = this
      getEntUid().then(function () {
        self.getFolderList(fid, options).then(function (data) {
          if (data.code === 'S_OK') {
            deferred.resolve(data)
          } else {
            deferred.reject(data)
          }
        })
      }, function (err) {
        deferred.reject(err)
      })

      return deferred.promise
    }

    /* 用来获取企业网盘所需要的Uid;
         * 此处如此设计是由于必须先取到uid才能进行folder和file的获取,
         * 而当folder获取之后再获取file,所以当folder获取之后uid已经获取到并缓存,不需要再获取
         */
    function getEntUid() {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'nf:getEntUid',
          sid: User.getCurrentUser().sid
        }
      }).then(function (data, status, headers, config) {
        if (data.code === 'S_OK') {
          const entUid = data['var']
          const userConfig = User.getCurrentUser().config
          userConfig.netfolder = {
            uid: entUid
          }
          User.getCurrentUser().save()
          deferred.resolve(data)
        } else {
          deferred.reject(data)
        }
      }, function (data, status, headers, config) {
        deferred.reject(data)
      })

      return deferred.promise
    }

    /* 用于外部取得uid */
    function getUid() {
      const $ajc = User.getConfig()['$ajc']
      return $ajc.nf.enfUid || ''
    }

    function prepareCheckUploadSizeLimit(options) {
      const deferred = $q.defer()
      const fid = options.fid ? options.fid : 0
      const attachId = options.attachId ? options.attachId : ''
      const size = options.size
      const uid = options.uid
      const query = {
        func: 'upload:prepareCheckUploadSizeLimit',
        sid: User.getCurrentUser().sid
      }

      if (options.folderType === 'ent') {
        query.uid = getUid()
      }
      User.getCurrentUser().simpleCall({
        query: query,
        data: {
          attachId: attachId,
          fid: fid,
          size: size,
          uid: uid
        }
      }).then(function (data, status, headers, config) {
        console.log(data)
      }, function (data, status, headers, config) {
        console.log(data)
        deferred.reject(data)
      })

      return deferred.promise
    }

    function prepareUpload(options) {
      const deferred = $q.defer()
      const folderType = options.folderType
      const composeId = options.composeId ? 'c:nf:' + options.composeId : ''
      const query = {
        func: 'upload:prepare',
        sid: User.getCurrentUser().sid
      }

      if (folderType === 'ent') {
        query.uid = getUid()
      }

      User.getCurrentUser().simpleCall({
        query: query,
        data: {
          inlined: options.inlined || false,
          size: options.size,
          composeId: composeId,
          fileName: options.fileName,
          attachId: -1
        }
      }).then(function (data, status, headers, config) {
        console.log(data)
        if (data.code == 'S_OK') {
          deferred.resolve(data)
        }
      }, function (data, status, headers, config) {
        if (data.code == 'FA_OVERFLOW') {
          $utils.$notify.set({message: $translate.instant('NETFOLDER.NF_OVERFLOW')})
          deferred.reject('overflow')
        } else {
          deferred.reject(data)
        }
      })

      return deferred.promise
    }

    // 上传相关,用uploadObject来保存xhr对象,用于取消上传

    const uploadMap = {}

    function getUploadXhr(file) {
      const xhr = uploadMap[file.$$hashKey]
      return xhr || null
    }

    function clearUploadXhr(file) {
      uploadMap[file.$$hashKey] = null
    }

    function upload(file, options) {
      const { composeId, attachmentId, folderType } = options
      uploadMap[file.$$hashKey] = $q.defer()
      const params = {
        composeId: composeId ? `c:nf:${composeId}` : '',
        attachmentId,
        blob: file,
        timeout: uploadMap[file.$$hashKey].promise
      }
      if (folderType === 'ent') {
        params.uid = getUid()
      }
      return globalMailService.uploadDirectData(params)
    }

    function moveToFolder(options) {
      const deferred = $q.defer()
      const composeId = options.composeId ? 'c:nf:' + options.composeId : ''
      const name = options.fileName ? options.fileName : 0
      const attachmentId = options.attachmentId
      const folderType = options.folderType
      const query = {
        func: 'upload:moveToNetFolder',
        sid: User.getCurrentUser().sid
      }
      if (folderType === 'ent') {
        query.uid = getUid()
      }

      const data = {
        sid: User.getCurrentUser().sid,
        composeId: composeId,
        item: name,
        attachmentId: attachmentId
      }
      User.getCurrentUser().simpleCall({
        query: query,
        data: data
      }).then(function (data, status, headers, config) {
        if (data.code === 'S_OK') {
          deferred.resolve(data)
        }
        console.log(data)
      }, function (data, status, headers, config) {
        console.log(data)
        deferred.reject(data)
      })

      return deferred.promise
    }

    /* 用作文件附件发信操作 */
    let file = null

    function setComposeFile(fileItem) {
      file = fileItem
    }

    function getComposeFile() {
      return file
    }

    function isUploader(uploader) {
      const user = User.getCurrentUser() || {}
      const userConfig = user.config || {}
      return uploader.indexOf(userConfig.email || '') !== -1
    }

    // 文件中转站文件续期
    function renewalFile(id) {
      const deferred = $q.defer()
      const params = {
        ids: [id]
      }
      Promise.wmCall('nf:renewalTrsFile', params).then(function(data) {
        if (data && data.code === 'S_OK') {
          deferred.resolve()
        }
      }, function(error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    return {
      getFolderList: getAllFolder,
      listFiles: listFiles,
      createFolder: createUserFolders,
      deleteFolder: deleteFolder,
      deleteFolder_R: deleteFolderR,
      reNameFolder: reNameFolder,
      searchFolders: searchFolders,
      searchFiles: searchFiles,
      downloadFile: downloadFile,
      updateFileInfo: updateFileInfo,
      deleteFiles: deleteFiles,
      getFileInfos: getFileInfos,
      getEntFolderList: getEntFolderList,
      getUid: getUid,
      getEntUid: getEntUid,
      getDownloadUrl: getDownloadUrl,
      prepareCheckUploadSizeLimit: prepareCheckUploadSizeLimit,
      prepareUpload: prepareUpload,
      moveToFolder: moveToFolder,
      upload: upload,
      setComposeFile: setComposeFile,
      getComposeFile: getComposeFile,
      getUploadXhr: getUploadXhr,
      clearUploadXhr: clearUploadXhr,
      isUploader: isUploader,
      renewalFile: renewalFile,
      listAttachments: listAttachments,
      getAttachmentDownloadUrl: getAttachmentDownloadUrl,
      readMessagePart: readMessagePart
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/netFolder/netFolderService.js